import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDataTable,{staticClass:"elevation-1",attrs:{"dense":"","headers":_vm.headers,"options":_vm.options,"items":_vm.gridData,"server-items-length":_vm.gridDataTotalCount,"footer-props":_vm.footerProps},on:{"update:options":function($event){_vm.options=$event},"click:row":_vm.HandleRowClick},scopedSlots:_vm._u([{key:"no-data",fn:function(){return [_c(VBtn,{attrs:{"color":"primary"},on:{"click":_vm.ReloadGrid}},[_vm._v(_vm._s(_vm.$t('Refresh')))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }